import { useDispatch } from 'react-redux';
import { IconGraphy } from '@leapeasy/ui-kit';
import styled from 'styled-components';
import { changeDemoAction } from 'store/actions/uiActions';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useDemoMask } from 'hooks/useDemoMask';
import { isAdminUser } from 'utils/roleAccess';

const ProfileToggleWrap = styled.div`
  width: 100%;
  margin-bottom: 12px;

  button {
    width: 100%;
    justify-content: center;
  }
`;

const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid ${({ $active }) => ($active ? '#7E3080' : '#EAEAEA')};
  background: ${({ $active }) => ($active ? '#F8F4F9' : 'transparent')};
  color: ${({ $active }) => ($active ? '#7E3080' : '#3C393D')};
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;

  &:hover {
    opacity: 0.9;
    background: #f8f4f9;
  }
`;

export const DemoModeToggle = ({ variant = 'topbar' }) => {
  const dispatch = useDispatch();
  const { isDemo } = useDemoMask();
  const currentUser = useCurrentUser();
  const isAdmin = isAdminUser(currentUser);

  if (!isAdmin) return null;

  const handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(changeDemoAction(!isDemo));
  };

  const tooltipTitle = isDemo
    ? 'Demo data on — PII masked for tutorials'
    : 'Demo data off — show real data';

  const content = (
    <ToggleButton
      type="button"
      $active={isDemo}
      onClick={handleToggle}
      role="switch"
      aria-checked={isDemo}
      aria-label={tooltipTitle}
      title={tooltipTitle}
    >
      <IconGraphy icon="General.Report" width={14} height={14} forceColor />
      {variant === 'topbar'
        ? isDemo
          ? 'Demo ON'
          : 'Demo'
        : isDemo
          ? 'Demo data on'
          : 'Demo data masking'}
    </ToggleButton>
  );

  if (variant === 'profile') {
    return (
      <ProfileToggleWrap onClick={(event) => event.stopPropagation()}>{content}</ProfileToggleWrap>
    );
  }

  return content;
};
